(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-model-chooser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('eg-model-chooser')) return;

    class EgModelChooser extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-card]').forEach((card) => {
          const first = card.querySelector('[data-swatch]');
          if (first) this.apply(card, first, false);
        });
        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('[data-swatch]');
          if (swatch) this.apply(swatch.closest('[data-card]'), swatch, true);
        });
      }

      apply(card, swatch, swapImage) {
        const data = swatch.dataset;
        const available = data.available === 'true';

        card.querySelectorAll('[data-swatch]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === swatch));
        });
        card.querySelector('[data-leather-name]').textContent = data.name;
        card.querySelectorAll('[data-link]').forEach((link) => (link.href = data.url));
        card.querySelector('[data-cta]').textContent = `View ${card.dataset.model} ${data.name}`;

        card.querySelector('[data-price-row]').classList.toggle('is-sold-out', !available);
        card.querySelector('[data-price]').textContent = available ? data.price : 'Sold out';
        const compare = card.querySelector('[data-compare]');
        compare.textContent = data.compare || '';
        compare.hidden = !(available && data.compare);
        const badge = card.querySelector('[data-badge]');
        badge.textContent = Number(data.badge) > 0 ? `–${data.badge}%` : '';
        badge.hidden = !(available && Number(data.badge) > 0);

        const media = card.querySelector('.eg-mc__media');
        const image = media?.querySelector('img');
        if (swapImage && image && data.src && image.getAttribute('src') !== data.src) {
          media.classList.add('is-loading');
          image.addEventListener('load', () => media.classList.remove('is-loading'), { once: true });
          image.srcset = data.srcset || '';
          image.src = data.src;
          image.alt = data.alt || '';
        }
      }
    }

    customElements.define('eg-model-chooser', EgModelChooser);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    getIds() {
      try {
        return JSON.parse(localStorage.getItem('viewedProducts') || '[]').map(String);
      } catch (error) {
        return [];
      }
    }

    async fetchCards(query) {
      const url = new URL('/search', location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');

      const sectionUrl = new URL(url);
      sectionUrl.searchParams.set('section_id', this.dataset.sourceSection);

      let response = await fetch(sectionUrl);
      // Fallback if the search template was rebuilt and its section id changed.
      if (!response.ok) response = await fetch(url);
      if (!response.ok) return [];

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return [...doc.querySelectorAll('.product-grid__item[data-product-id]')];
    }

    async render() {
      const currentId = this.dataset.currentProductId;
      const max = Number(this.dataset.maxProducts) || 4;
      const ids = this.getIds()
        .filter((id) => id && id !== currentId)
        .slice(0, max);
      if (ids.length === 0) return;

      let cards;
      try {
        cards = await this.fetchCards(ids.map((id) => `id:${id}`).join(' OR '));
      } catch (error) {
        return;
      }

      const byId = new Map(cards.map((card) => [card.dataset.productId, card]));
      const list = this.querySelector('.recently-viewed__list');
      const ordered = ids.map((id) => byId.get(id)).filter(Boolean);
      if (ordered.length === 0) return;

      for (const card of ordered) {
        card.removeAttribute('id');
        card.removeAttribute('ref');
        // Drop the search tracking params (_pos, _sid, _ss) from card links.
        card.querySelectorAll('a[href*="_sid="]').forEach((link) => {
          const href = new URL(link.getAttribute('href'), location.origin);
          ['_pos', '_sid', '_ss'].forEach((param) => href.searchParams.delete(param));
          link.setAttribute('href', href.pathname + href.search);
        });
        list.append(document.importNode(card, true));
      }

      this.hidden = false;
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
